module.exports = __webpack_public_path__ + "img/5f_r_twodays@2x.9b530271.png";